import { debugLogReducer } from "../helpers/debugHelper";
import { types } from "../types/types";

const initialState = {

  financials: [],

  financial: {},
  financialSaved: {},
  financialSelected: {},

  financialsP: [],
  totalItemsFinancialP: 0,
  totalPagesFinancialP: 0,
  currentPageFinancialP: 0,

  financialsS: [],
  totalItemsFinancialS: 0,
  totalPagesFinancialS: 0,
  currentPageFinancialS: 0,

  searchTextState: "",

  moreThanOneIsSelected: false,
  numberFinancialSelected: 0,

  isLoadingFinancials: false
};

const countSelected = (list) => list.filter(item => item.isSelected).length;

export const financialReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FINANCIAL_START_REGISTER_ADMIN:

      return {
        ...state,
        financialSaved: action.payload,
      };

    case types.FINANCIAL_UPDATE:
      if (state.financialsS.length > 0) {
        return {
          ...state,
          financialsS: state.financialsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          financialsP: state.financialsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          financialsP: state.financialsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.FINANCIAL_DELETE:
      if (state.financialsS.length > 0) {
        return {
          ...state,
          financialsS: state.financialsS.filter((usr) => usr.id !== action.payload),
          financialsP: state.financialsP.filter((usr) => usr.id !== action.payload),
          financialSelected: {},
        };
      } else {
        return {
          ...state,
          financialsP: state.financialsP.filter((usr) => usr.id !== action.payload),
          financialSelected: {},
        };
      }

    case types.FINANCIAL_START_LOADING_PAGINATED:
      return {
        ...state,
        financialsP: action.payload.financialsP,
        totalItemsFinancialP: action.payload.totalItems,
        totalPagesFinancialP: action.payload.totalPages,
        currentPageFinancialP: action.payload.currentPage,
      };

    case types.FINANCIAL_START_LOADING_FINANCIAL_PAGINATED:

      return {
        ...state,
        financialsS: action.payload.financialsP,
        totalItemsFinancialS: action.payload.totalItems,
        totalPagesFinancialS: action.payload.totalPages,
        currentPageFinancialS: action.payload.currentPage,
      };

    case types.FINANCIAL_START_SEARCH_PAGINATED:
      return {
        ...state,
        financialsS: action.payload.financialsP,
        totalItemsFinancialS: action.payload.totalItems,
        totalPagesFinancialS: action.payload.totalPages,
        currentPageFinancialS: action.payload.currentPage,
      };

    case types.FINANCIAL_SELECT:
      return {
        ...state,
        financialSelected: action.payload,
      };

    case types.FINANCIAL_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        financialsS: [],
        totalItemsFinancialS: 0,
        totalPagesFinancialS: 0,
        currentPageFinancialS: 0,

        numberFinancialSelected: 0
      };

    case types.FINANCIAL_CLEAN_PAGINATED:
      return {
        ...state,
        financialsP: [],
        totalItemsFinancialP: 0,
        totalPagesFinancialP: 0,
        currentPageFinancialP: 0,

      };

    case types.FINANCIAL_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.FINANCIAL_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.FINANCIAL_CLEAN_SAVED:
      return {
        ...state,
        financialSaved: {},
      };

    /*
  case types.FINANCIAL_LIST_UPDATE_SELECTED:
    
    if (state.financialsS.length > 0) {
      return {
        ...state,
        financialsS: state.financialsS.map((usr) => (usr.id === action.payload ? { ...usr, isSelected: !usr.isSelected } : usr)),

      };
    }
    break;
    */
    case types.FINANCIAL_LIST_UPDATE_SELECTED: {
      const id = action.payload;
      const currentSelectedCount = countSelected(state.financialsS);
      const targetItem = state.financialsS.find(item => item.id === id);

      // Si va a seleccionar uno nuevo y ya hay 9, no hacer nada
      if (!targetItem.isSelected && currentSelectedCount >= 9) return state;

      const newFinancials = state.financialsS.map(item =>
        item.id === id ? { ...item, isSelected: !item.isSelected } : item
      );

      const newCount = countSelected(newFinancials);

      return {
        ...state,
        financialsS: newFinancials,
        numberFinancialSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Selección masiva (Primeros 9 o todos si hay menos)
    case types.FINANCIAL_SELECT_ALL_LIMIT: {
      const newFinancials = state.financialsS.map((item, index) => ({
        ...item,
        isSelected: index < 9 // Selecciona solo los primeros 9
      }));

      const newCount = countSelected(newFinancials);

      return {
        ...state,
        financialsS: newFinancials,
        numberFinancialSelected: newCount,
        moreThanOneIsSelected: newCount > 1
      };
    }

    // Limpiar todo
    case types.FINANCIAL_CLEAN_ALL_SELECTED: {
      return {
        ...state,
        financialsS: state.financialsS.map(item => ({ ...item, isSelected: false })),
        numberFinancialSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    //Clean Without list
    case types.FINANCIAL_CLEAN_ALL_WITHOUT_LIST: {
      return {
        ...state,
        numberFinancialSelected: 0,
        moreThanOneIsSelected: false
      };
    }

    case types.FINANCIAL_GET_MORE_THAN_ONE_SELECTED:

      debugLogReducer(":: FINANCIAL_GET_MORE_THAN_ONE_SELECTED");

      if (state.financialsS.length > 0) {
        return {
          ...state,
          moreThanOneIsSelected: getMoreThanOneIsSelected(state)
        };
      }
      break;

    case types.FINANCIAL_LIST_SET_NUMBER_SELECTED:
      debugLogReducer(":: FINANCIAL_LIST_SET_NUMBER_SELECTED");

      if (state.financialsS.length > 0) {
        return {
          ...state,
          numberFinancialSelected: action.payload
        };
      }
      break;

    case types.FINANCIAL_CLEAN_SEARCH_INFORMATION:

      debugLogReducer(":: FINANCIAL_CLEAN_SEARCH_INFORMATION");

      return {
        ...state,
        numberFinancialSelected: 0
      };

    case types.FINANCIAL_IS_LOADING:

      return {
        ...state,
        isLoadingFinancials: true
      };

    case types.FINANCIAL_IS_LOADING_FINISH:

      return {
        ...state,
        isLoadingFinancials: false
      };

    default:
      return state;
  }
};

const getMoreThanOneIsSelected = (state) => {
  debugLogReducer(":: getMoreThanOneIsSelected");

  let flagMoreThanOne = false;
  let counterFlagMoreThanOneIsSelected = 0;

  if (state.financialsS.length > 0) {
    state.financialsS.forEach(element => {

      if (element.isSelected) {
        counterFlagMoreThanOneIsSelected = counterFlagMoreThanOneIsSelected + 1;
      }
    });
  }

  if (counterFlagMoreThanOneIsSelected > 1) {
    flagMoreThanOne = true;
  }

  return flagMoreThanOne;
}